module.exports = require("jwt-decode");